import { gql } from 'graphql-request'

export namespace AccessInstructionMutations {
  export function updateAccessInstruction() {
    return gql`
      mutation updateAccessInstructions($accessInstruction: UpdateAccessInstruction) {
        updateAccessInstructions(accessInstruction: $accessInstruction)
      }
    `
  }
}
